import { alpha, backdropClasses } from '@mui/material';
import MuiModal, { ModalProps } from '@mui/material/Modal';
import { makeStyles } from 'tss-react/mui';

import { Close } from './Close';

interface Props extends Omit<ModalProps, 'onSubmit'> {
  onClose: () => void;
}

export function Modal({ children, ...props }: Props): JSX.Element {
  const { classes } = useStyles();
  const { onClose } = props;

  return (
    <MuiModal {...props} className={classes.modal}>
      <div onClick={onClose} className={classes.area}>
        <div
          className={classes.container}
          onClick={event => event.stopPropagation()}
        >
          {children}

          <Close className={classes.close} onClose={onClose} />
        </div>
      </div>
    </MuiModal>
  );
}

const useStyles = makeStyles()(theme => ({
  area: {
    padding: 0,
    background: 'none',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
    overflowY: 'scroll',

    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
    },
  },

  modal: {
    [`& .${backdropClasses.root}`]: {
      backgroundColor: alpha(theme.palette.grey[900], 0.1),
    },
  },

  container: {
    background: 'none',
    border: 'none',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 580,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(4),
    width: '100%',
    padding: theme.spacing(15),
    height: 'max-content',

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(16, 8),
      borderRadius: 0,
      minHeight: '100vh',
      maxWidth: '100%',
    },
  },

  close: {
    position: 'absolute',
    top: 32,
    right: 32,

    [theme.breakpoints.down('sm')]: {
      top: 62,
      right: 32,
    },
  },
}));
